module.exports = __webpack_public_path__ + "81626e2c7e8a9cace6aae8f8777e7a25.jpg";